function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.83 13.222L.556 1.948 1.948.556 13.222 11.83 25.052 0l1.392 1.392-11.83 11.83L27 25.61 25.608 27 13.222 14.614l-11.83 11.83L0 25.052z",
  fill: "#8781bd",
  fillRule: "evenodd"
});

function SvgClose27Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 27,
    width: 27
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI3IiB2aWV3Qm94PSIwIDAgMjcgMjciIHdpZHRoPSIyNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xMS44MzAyIDEzLjIyMjItMTEuMjc0MjQtMTEuMjc0MjUgMS4zOTE4LTEuMzkxNzk0IDExLjI3NDI0IDExLjI3NDI0NCAxMS44MzAzLTExLjgzMDM1Mzk0IDEuMzkxOCAxLjM5MTc5Mzk0LTExLjgzMDMgMTEuODMwMzYgMTIuMzg2MiAxMi4zODYzLTEuMzkxNyAxLjM5MTctMTIuMzg2My0xMi4zODYyLTExLjgzMDIgMTEuODMwMS0xLjM5MTc5OTgzLTEuMzkxOHoiIGZpbGw9IiM4NzgxYmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgClose27Px as ReactComponent };